export enum DropdownsEnum {
  INDUSTRY = 'industry',
  JOB_TITLE = 'jobTitle',
  JOB_CATEGORY = 'jobCategory',
  EDUCATION = 'education',
  POSITION_TYPE = 'positionType',
  QUALIFICATION = 'qualification',
  SKILL = 'skill',
  LANGUAGE = 'language',
  EXPERIENCE_LEVEL = 'experienceLevel',
}
